//DIRECTIVE USGE
/*
<div v-number-counter="
{
    countFrom   : 0,
    countTo     : 10,
    duration    : 1000,
    format      : undefined
}">0</div>
*/

const start = ( element ) =>
{
    const { countFrom, countTo, duration, format, skipZero } = element.counter;

    if( skipZero && countTo <= 0 ){ return; }

    const animate = () =>
    {
        let startTime;

        const step = ( currentTime ) =>
        {
            if( !startTime )
            {
                startTime = currentTime;
            }

            const progress      = Math.min(( currentTime - startTime ) / duration, 1);
            const currentNumber = Math.floor(progress * ( countTo - countFrom ) );

            element.textContent = `${ format ? format( currentNumber + countFrom ) : currentNumber + countFrom }`;

            if( progress < 1 )
            {
                element.animationFrameID = window.requestAnimationFrame( step );
            }
            else
            {
                window.cancelAnimationFrame( element.animationFrameID );

                element.counter.countFrom = element.counter.countTo;
            }
        };

        window.requestAnimationFrame( step );
    };

    animate();
}

export default
{
    mounted( element, binding )
    {
        element.counter = binding.value; start( element );
    },
    updated( element, binding )
    {
        element.counter.countTo = binding.value.countTo; start( element );
    },
    unmounted( element )
    {
        window.cancelAnimationFrame( element.animationFrameID );
    }
}